export default {
  common: {
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    back: 'Back',
    close: 'Close',
    add: 'Add',
    send: 'Send',
    sending: 'Sending...',
    saving: 'Saving...',
    loading: 'Loading...',
    search: 'Search',
    update: 'Update',
    create: 'Create',
    creating: 'Creating...',
    transfer: 'Transfer',
    approve: 'Approve',
    reject: 'Reject',
    ok: 'Got it',
    name: 'Name',
    username: 'Username',
    password: 'Password',
    email: 'E-mail',
    date: 'Date',
    status: 'Status',
    type: 'Type',
    quantity: 'Quantity',
    description: 'Description',
    project: 'Project',
    task: 'Task',
    logout: 'Sign out',
    notifications: 'Notifications',
    settings: 'Settings',
    draft: 'Draft',
    sent: 'Sent',
    active: 'Active',
    inactive: 'Inactive',
    priority: 'Priority',
    language: 'Language',
    yes: 'Yes',
    no: 'No',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    required: 'Required',
    optional: 'Optional',
    all: 'All',
    none: 'None',
    upload: 'Upload file',
    download: 'Download',
    print: 'Print',
    actions: 'Actions',
    details: 'Details',
    filters: 'Filters',
    results: 'Results',
    noResults: 'No results found',
    total: 'Total',
    of: 'of',
    verified: 'verified',
    pending: 'Pending',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },

  auth: {
    login: 'Sign in',
    loginTitle: 'Sign in to your account',
    logout: 'Sign out',
    register: 'Register',
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset password',
    usernameOrEmail: 'Username or e-mail',
    enterPassword: 'Enter your password',
    enterUsername: 'Enter your username',
    loginError: 'Incorrect username or password.',
    sessionExpired: 'Session expired. Please sign in again.',
  },

  nav: {
    dashboard: 'Control panel',
    overview: 'Overview',
    documents: 'Documents',
    viewDocuments: 'View documents',
    manageProjects: 'Manage projects',
    viewProjects: 'View projects',
    manageUsers: 'Manage users',
    viewUsers: 'View users',
    manageWarehouse: 'Manage Warehouse',
    viewWarehouse: 'View Warehouse',
    manageMachinery: 'Manage Machinery',
    viewMachinery: 'View Machinery',
    manageSystem: 'System settings',
    projects: 'Projects',
    myProjects: 'My projects',
    myTasks: 'My tasks',
    reports: 'Reports',
    drawings: 'Drawings',
    warehouse: 'Warehouse',
    checkStock: 'Check stock',
    requests: 'Requests',
    requestItem: 'Request item',
    tickets: 'Tickets',
    messages: 'Messages',
    adminMode: 'Admin mode',
    standardMode: 'Standard mode',
    analystMode: 'Analyst mode',
    createReport: 'Create report',
    createReports: 'Construction reports',
    dailyReport: 'Daily construction report',
    incidentReport: 'Incident report',
    safetySection: 'Workplace safety',
    safetyDialog: 'Safety toolbox talks',
    workPermit: 'Critical work permit',
    occurrenceReport: 'Occurrence report',
    settingsMenu: 'Settings',
  },

  profile: {
    editProfile: 'Edit profile',
    displayName: 'Name',
    usernameLabel: 'Username',
    passwordLabel: 'Password',
    changePassword: 'Change password',
    appearance: 'Appearance',
    lightMode: 'Light mode',
    darkMode: 'Dark mode',
    languageLabel: 'Language',
    cropTitle: 'Crop profile photo',
    cropUse: 'Use this area',
    zoom: 'Zoom',
    currentPassword: 'Confirm current password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    emailVerified: 'verified',
    emailChange: 'Change',
    emailSendCode: 'Send code',
    emailConfirm: 'Confirm',
    emailResend: '← Resend code',
    emailCancelChange: 'Cancel',
    emailSending: 'Sending...',
    emailVerifying: 'Verifying...',
    emailHint: 'Code sent to {email}. Check your inbox and spam.',
    emailSuccess: 'E-mail {email} successfully verified.',
    emailInvalidError: 'Please enter a valid e-mail.',
    emailGenericError: 'Error sending code.',
    emailInvalidCode: 'Invalid code.',
    passwordFillAll: 'Please fill in all password fields.',
    passwordWrong: 'Current password is incorrect.',
    passwordMismatch: 'New password confirmation does not match.',
    saveFillAll: 'Please fill in name and username.',
    saveFinishPassword: 'Please finish or cancel the password change before saving.',
    avatarAlt: 'profile',
  },

  dashboard: {
    overview: 'Overview',
    myProjects: 'My projects',
    myTasks: 'My tasks',
    activeProjects: 'Active projects',
    completedTasks: 'Completed tasks',
    pendingTasks: 'Pending tasks',
    recentActivity: 'Recent activity',
    noProjects: 'No projects found.',
    noTasks: 'No tasks found.',
    createProject: 'Create project',
    projectName: 'Project name',
    startDate: 'Start date',
    endDate: 'End date',
  },

  projects: {
    title: 'Projects',
    newProject: 'New project',
    projectName: 'Project name',
    startDate: 'Start',
    endDate: 'End',
    progress: 'Progress',
    team: 'Team',
    gantt: 'Planning',
    files: 'Files',
    tickets: 'Tickets',
    warehouse: 'Warehouse',
    dds: 'Safety Talk',
    reports: 'Reports',
    noProjects: 'No projects.',
    deleteConfirm: 'Are you sure you want to delete this project?',
  },

  tasks: {
    title: 'Tasks',
    newTask: 'New task',
    taskName: 'Task name',
    assignee: 'Assignee',
    dependencies: 'Dependencies',
    duration: 'Duration (days)',
    startDate: 'Start',
    endDate: 'End',
    progress: 'Progress',
    addProgress: 'Log progress',
    noTasks: 'No tasks.',
    blocked: 'Blocked',
    inProgress: 'In progress',
    done: 'Done',
    deleteConfirm: 'Delete this task?',
  },

  warehouse: {
    title: 'Warehouse',
    stock: 'Stock',
    requestItem: 'Request item',
    requests: 'Requests',
    addItem: 'Add item',
    itemName: 'Item name',
    category: 'Category',
    unit: 'Unit',
    available: 'Available',
    reserved: 'Reserved',
    transferItem: 'Transfer item',
    reportDamage: 'Report damage',
    provideEquipment: 'Provide equipment',
    noItems: 'No items in stock.',
    noRequests: 'No requests.',
    approveRequest: 'Approve request',
    rejectRequest: 'Reject request',
    requestStatus: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected',
      delivered: 'Delivered',
    },
  },

  safety: {
    title: 'Safety',
    dds: 'Safety Talk',
    ddsTitle: 'Daily Safety Dialogue',
    newDds: 'New Safety Talk',
    occurrences: 'Occurrences',
    permits: 'Permits',
    createDialog: 'Create dialogue',
    createOccurrence: 'Log occurrence',
    createPermit: 'Create permit',
    topic: 'Topic',
    presenter: 'Presenter',
    attendees: 'Attendees',
    date: 'Date',
    noSafety: 'No safety records.',
  },

  tickets: {
    title: 'Tickets',
    newTicket: 'New ticket',
    subject: 'Subject',
    category: 'Category',
    openedBy: 'Opened by',
    assignedTo: 'Assigned to',
    openTickets: 'Open tickets',
    closedTickets: 'Closed tickets',
    noTickets: 'No tickets.',
    status: {
      open: 'Open',
      inProgress: 'In progress',
      closed: 'Closed',
    },
  },

  users: {
    title: 'Users',
    newUser: 'New user',
    role: 'Role',
    roles: {
      adminMaster: 'Master Admin',
      adminObra: 'Site Admin',
      user: 'User',
    },
    noUsers: 'No users.',
    deleteConfirm: 'Delete this user?',
    manageRoles: 'Manage roles',
    manageUsers: 'User management',
    userList: 'User list',
  },

  system: {
    title: 'System settings',
    siteName: 'System name',
    logo: 'Logo',
    loginBackground: 'Login background',
    primaryColor: 'Primary color',
    save: 'Save settings',
    saved: 'Settings saved.',
  },

  reports: {
    title: 'Reports',
    daily: 'Daily report',
    incident: 'Incident report',
    noReports: 'No reports.',
    createReport: 'Create report',
    date: 'Date',
    author: 'Author',
    content: 'Content',
  },

  machinery: {
    title: 'Heavy Machinery',
    newMachine: 'New equipment',
    machineName: 'Name',
    model: 'Model',
    plate: 'Plate',
    status: 'Status',
    noMachinery: 'No equipment.',
  },

  messenger: {
    title: 'Messages',
    newMessage: 'New message',
    noMessages: 'No messages.',
    typeMessage: 'Type a message...',
    send: 'Send',
  },
}
